module.exports = "/static/assets/633b86695a4c4660ea61a22765eb9a7f.png";